import { get, put } from '../axios'

// 波形关联标签-列表
export const getRelatedOption = params => get(`/web/waveform/related/option`, params);

// 波形关联标签-关联
export const updateRelatedTag = params => put(`/web/waveform/related/update`, params);